module.exports = __webpack_public_path__ + "img/coc-logo-pefc.1ae81fb4.png";